
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class NewsItem extends Vue {
  @Prop() item!: any;
}
